"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var expanded_theme_1 = require("@wix/wix-vod-constants/dist/app-settings/expanded-theme");
var item_loading_scss_1 = tslib_1.__importDefault(require("./item-loading.scss"));
var ItemLoading = /** @class */ (function (_super) {
    tslib_1.__extends(ItemLoading, _super);
    function ItemLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemLoading.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, active = _b.active, style = _b.style;
        return (react_1.default.createElement("div", { "data-hook": "item-loading", style: style, className: (0, classnames_1.default)(item_loading_scss_1.default.container, (_a = {},
                _a[item_loading_scss_1.default.light] = theme === expanded_theme_1.EXPANDED_THEME_VALUES.LIGHT,
                _a[item_loading_scss_1.default.dark] = theme === expanded_theme_1.EXPANDED_THEME_VALUES.DARK,
                _a[item_loading_scss_1.default.universal] = !theme,
                _a[item_loading_scss_1.default.active] = active,
                _a)) }));
    };
    return ItemLoading;
}(react_1.default.Component));
exports.default = ItemLoading;
//# sourceMappingURL=item-loading.js.map